<template>
<base-modal title="Edit Hero">
  <form>
    <div class="columns">
      <div class="column">
        <file-input required
          button-text="Choose a file"
          class="is-boxed"
          hint="1900px x 575px"
          @select="setFile"
          :error="errors.file">
          Banner Image
        </file-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          v-bind="{ working }"
          @submit="save"
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>  
</template>

<script>
import { save as saveHero } from '@/api/hero'

export default {
  
  props: {
    heroId: Number
  },

  data: () => ({
    working: false,
    file: ''
  }),

  methods: {
    setFile(file) {
      this.file = file
    },

    save() {
      this.working = true
      saveHero({
        heroId: this.heroId,
        file: this.file
      }, () => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }
}
</script>
